import { ThemeOptions } from '@mui/material';

import { capitalDesignTokens } from '../../capital_design_tokens';


export const MuiTooltip: ThemeOptions['components']['MuiTooltip'] = {
  styleOverrides: {
    tooltip: ({ theme }) => ({
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
      fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyXSmall,
      lineHeight: capitalDesignTokens.foundations.typography.lineHeight.bodyXSmall,
      padding: theme.spacing(1),
      borderRadius: capitalDesignTokens.foundations.units.unitHalf,
      borderColor: theme.palette.common.black,
      minHeight: 26,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }),
    arrow: ({ theme }) => ({
      color: theme.palette.common.black
    })
  }
};
